import { render, staticRenderFns } from "./openstreetmap.vue?vue&type=template&id=96d38aac&"
import script from "./openstreetmap.vue?vue&type=script&lang=js&"
export * from "./openstreetmap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('96d38aac')) {
      api.createRecord('96d38aac', component.options)
    } else {
      api.reload('96d38aac', component.options)
    }
    module.hot.accept("./openstreetmap.vue?vue&type=template&id=96d38aac&", function () {
      api.rerender('96d38aac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-287ro39aj7S7n/JS/comp/openstreetmap.vue"
export default component.exports